<template>
	<div>
		<div class="level">
			<div class="level-left">
				<p class="label">{{ label }}</p>
				<p v-if="description">{{ description }}</p>
			</div>
			<div class="level-right">
				<button
					class="button is-primary is-small"
					@click.prevent="addFeature"
				>
					<dc-icon icon="plus" />
					<span>Selling point</span>
				</button>
			</div>
		</div>

		<draggable
			:list="points"
			:group="{ draggable: '.key-feature', dragClass: '.fa-bars' }"
			@end="end"
		>
			<div
				v-for="(_name, index) in points"
				:key="index"
				class="key-feature"
			>
				<div class="dragging-text">
					<b-input
						v-model.trim="points[index]"
						:maxlength="50"
						:has-counter="true"
						placeholder="Briefly describe a unique selling point of your facility"
						@blur="myBlur"
					></b-input>
					<div class="controls">
						<span
							class="delete-item"
							@click.prevent="removeFeature(index)"
							><i class="fa fa-times fa-fw"></i
						></span>
						<i class="fa fa-bars fa-fw dragger"></i>
					</div>
				</div>
			</div>
		</draggable>
	</div>
</template>

<script>
import draggable from "vuedraggable";
import fieldArrayMixin from "@lab/utils/fieldArrayMixin";

export default {
	components: { draggable },
	mixins: [fieldArrayMixin],
	props: {
		label: {
			type: String,
			required: true
		},
		description: {
			type: String,
			default: () => null
		}
	},
	data() {
		return {
			points: []
		};
	},
	computed: {
		value() {
			return this.$store.getters.formFieldValue(this.form, this.name);
		}
	},
	mounted() {
		this.points = JSON.parse(JSON.stringify(this.value));
	},
	methods: {
		addFeature() {
			this.points.push("");
		},
		myBlur() {
			this.$store.commit("form_field_leave", {
				form: this.form,
				field: this.name,
				value: JSON.parse(JSON.stringify(this.points))
			});
			this.validate(this.name);
		},
		removeFeature(index) {
			this.points.splice(index, 1);
			this.myBlur();
		},
		end(change) {
			this.myBlur();
		}
	}
};
</script>

<style lang="scss" scoped>
.key-feature {
	margin-bottom: 10px;
	position: relative;
}
.controls {
	position: absolute;
	right: 0;
	top: 0.4em;
}
.delete-item {
	cursor: pointer;
}
.dragger {
	cursor: grab;

	.sortable-chosen &,
	.sortable-ghost & {
		cursor: grabbing;
	}
}
</style>

<style scoped>
.dragging-text >>> .input {
	width: 95%;
	vertical-align: middle;
}
.dragging-text >>> .character-count {
	font-size: 0.7em;
	margin: 5px 0;
}
.dragging-text >>> .control {
	margin-right: 25px;
}
.dragging-text >>> .counter {
	margin-right: 5%;
	visibility: visible !important;
}
</style>
